<script>
import { Bar } from 'vue-chartjs'

export default {
    extends: Bar,
    name: 'BarChart',
    // 1. Définition de la PROPRIÉTÉ pour recevoir les données
    props: {
        clientData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                plugins: {
                    datalabels: {
                        color: '#FFFFFF'
                    }
                }
            }
        }
    },
    computed: {
        // 2. Calcul des données au format Chart.js
        formattedChartData() {
            const labels = [];
            const dataValues = [];

            // Parcourir le tableau de données client
            this.clientData.forEach(item => {
                // Ajouter le nom du client comme libellé (Label)
                labels.push(item.nom_client);
                // Ajouter le total des dossiers (converti en nombre) comme valeur de données
                dataValues.push(parseInt(item.total_client));
            });

            return {
                labels: labels,
                datasets: [
                    {
                        label: "Nombre de Dossiers par Client",
                        data: dataValues,
                        // Utilisation d'une couleur d'accent plus douce (comme dans la proposition de design)
                        backgroundColor: '#60A39C',
                        // Mettre les bordures de la même couleur pour un meilleur look
                        borderColor: '#508C86',
                        borderWidth: 1
                    }
                ]
            };
        }
    },
    watch: {
        clientData: {
            handler() {
                this.renderChart(this.formattedChartData, this.chartOptions);
            },
            deep: true
        }
    },
    mounted() {
        this.renderChart(this.formattedChartData, this.chartOptions);
    }
}
</script>